import React from "react";
import { useAuth } from "../../utils/AuthContext";
import ManageBusiness from "./modals/ManageBusiness";
import "../../css/pages/user_pages/UserDashboard.css";

const UserDashboard = () => {
    const { user } = useAuth();

    return (
        <div className="user-dashboard">
            <h1>Welcome Back, {user.user_full_name}!</h1>

            <ManageBusiness />
        </div>
    );
};

export default UserDashboard;
